var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mobile)?_c('mobile'):_c('pc')
}
var staticRenderFns = []

export { render, staticRenderFns }